import React from 'react'

import data from '../../../../data/reservoirs'
import { ReservoirIcon } from '../../../../icons'

import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const Reservoirs = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="reservoirs"
            icon={() => <ReservoirIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as ReservoirDescription }

export default Reservoirs
